import { render, staticRenderFns } from "./OrganizationPeerGroup.vue?vue&type=template&id=60b86d9a&"
import script from "./OrganizationPeerGroup.vue?vue&type=script&lang=ts&"
export * from "./OrganizationPeerGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports